var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-0 py-0 mx-0 my-0 h-100 w-100",attrs:{"flat":""}},[_c('explorer-toolbar'),_c('ExplorerContent',{on:{"input":id => _vm.$router.push(`knowledge/${id}/view`),"folder":id => _vm.$router.push(`/knowledge/explorer?folder_id=${id}`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }